import fetchIt from './fetchIt';
import { DefaultResponse, User, UserResponse } from '@vindr/services/interfaces';

export interface ResponseFetchPresentationState extends DefaultResponse {
  data: {
    id: string;
    metadata: any;
    sop_instance_uid: string;
    series_instance_uid: string;
    study_instance_uid: string;
    created_at: string;
    updated_at: string;
    updated_user: User;
    user: User; // creator
    user_id: string; // creator_id
  }[];
}

export const getPresentationStates = async (params = {}, headers = {}) => {
  if (!window?.config?.risURL) return;

  const data = await fetchIt.get(`presentation_states/v1?${new URLSearchParams(params).toString()}`);
  const jsonData = await data.json();
  return jsonData as ResponseFetchPresentationState;
};

export const createPresentationState = async (body, headers = {}) => {
  if (!window?.config?.risURL) return;

  const data = await fetchIt.post('presentation_states/v1', {
    json: body,
    redirect: 'follow',
    headers,
  });

  return await data?.json();
};

export const updatePresentationState = async (body, headers = {}) => {
  if (!window?.config?.risURL) return;

  const data = await fetchIt.put(`presentation_states/v1/${body.id}`, {
    json: body,
    redirect: 'follow',
    headers,
  });

  return await data?.json();
};

export const deletePresentationState = async (body, headers = {}) => {
  if (!window?.config?.risURL) return;

  const data = await fetchIt.delete(`presentation_states/v1`, {
    json: body,
    redirect: 'follow',
    headers,
  });

  return await data?.json();
};
